import { render, staticRenderFns } from "./opioid_list.vue?vue&type=template&id=59cd6562&"
import script from "./opioid_list.vue?vue&type=script&lang=js&"
export * from "./opioid_list.vue?vue&type=script&lang=js&"
import style0 from "./opioid_list.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports